export default "__VITE_ASSET__DOGijhBQ__"